<template>
    <v-dialog v-model="dialog" width="800">
        <v-card class="elevation-12">
            <v-form>
                <v-card-text>
                    <v-layout align-center justify-center row mb-2>
                        <v-img width="100%" height="100%" src="Attraction/suburban.png">
                        </v-img>
                    </v-layout>

                    <table class="my-table" style="width: 100%">
                        <tr class="my-table">
                            <th class="my-table" :style="`width: ${header.width}%;`" v-for="header in headers"
                                :key="header.value">
                                {{ header.name }}
                            </th>
                        </tr>
                        <tr class="my-table" :style="rowStyle(row)" v-for="row in rows" :key="row.value">
                            <td class="my-table">{{ row.text }}</td>

                            <td class="my-table" :style="`text-align: center;` + ratingStyle" v-if="row.type == 0">
                                <star-rating :read-only="true" v-model="row.rating" style="justify-content: center"
                                    :increment="1" :max-rating="5" inactive-color="#000" active-color="#f00"
                                    :star-size="mobile_break ? 30 : 10" :show-rating="false">
                                </star-rating>
                            </td>
                            <td class="my-table" v-else-if="row.type == 1">&nbsp;</td>
                            <td class="my-table" v-else>{{ total }}</td>

                            <td class="my-table" style="text-align: center; max-height: 35px" v-if="row.type == 0">

                                <v-tooltip max-width="200px" bottom>
                                    <template v-slot:activator="{ on }">
                                        <span v-on="on">
                                        <input  disabled style="line-height: 35px; width: 100%" type="text"
                                            v-model="row.comment" />
                                        </span>
                                    </template>
                                    <span>{{row.comment}}</span>
                                </v-tooltip>
                            </td>
                            <td class="my-table" v-else>&nbsp;</td>
                        </tr>
                    </table>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="hide" color="primary">close</v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
    import StarRating from "vue-star-rating";
    export default {
        name: 'SupplierEvalDialog',
        data() {
            return {
                dialog: false,
                value: 0,
                item: null,

                headers: [{
                        value: 1,
                        name: "Quality",
                        width: 30,
                    },
                    {
                        value: 2,
                        name: "Rating",
                        width: 15,
                    },
                    {
                        value: 3,
                        name: "Comments",
                        width: 45,
                    },
                ],
                rows: [{
                        value: 1,
                        text: "A. Quality Service provided",
                        rating: 0,
                        comment: "",
                        comment_prop: "QualityOfServiceComments",
                        rating_prop: "QualityOfServiceRating",
                        type: 0,
                    },
                    {
                        value: 2,
                        text: "B. Response Times",
                        rating: 0,
                        comment: "",
                        comment_prop: "ResponseTimeComments",
                        rating_prop: "ResponseTimeRating",
                        type: 0,
                    },
                    {
                        value: 3,
                        text: "C. Food Safety Compliance",
                        rating: 0,
                        comment: "",
                        comment_prop: "FoodSafteyComplianceComments",
                        rating_prop: "FoodSafteyComplianceRating",
                        type: 0,
                    },
                    {
                        value: 4,
                        text: "D. NCR raised against Service provider",
                        rating: 0,
                        comment: "",
                        comment_prop: "NCRRaisedAgainstServiceProviderComments",
                        rating_prop: "NCRRaisedAgainstServiceProviderRating",
                        type: 0,
                    },
                    {
                        value: 5,
                        text: "",
                        rating: 0,
                        comment: "",
                        comment_prop: "",
                        rating_prop: "",
                        type: 1,
                    },
                    {
                        value: 6,
                        text: "Performance",
                        rating: 0,
                        comment: "",
                        comment_prop: "",
                        rating_prop: "",
                        type: 1,
                    },
                    {
                        value: 7,
                        text: "A. Technical Ability",
                        rating: 0,
                        comment: "",
                        comment_prop: "TechnicalAbilityComments",
                        rating_prop: "TechnicalAbilityRating",
                        type: 0,
                    },
                    {
                        value: 8,
                        text: "B. Capability",
                        rating: 0,
                        comment: "",
                        comment_prop: "CapabilityComments",
                        rating_prop: "CapabilityRating",
                        type: 0,
                    },
                    {
                        value: 9,
                        text: "C. Technical Assistance",
                        rating: 0,
                        comment: "",
                        comment_prop: "TechnicalAssistanceComments",
                        rating_prop: "TechnicalAssistanceRating",
                        type: 0,
                    },
                    {
                        value: 10,
                        text: "D. Would you consider renewing contract",
                        rating: 0,
                        comment: "",
                        comment_prop: "RenewContractComments",
                        rating_prop: "RenewContractRating",
                        type: 0,
                    },
                    {
                        value: 11,
                        text: "",
                        rating: 0,
                        comment: "",
                        comment_prop: "",
                        rating_prop: "",
                        type: 1,
                    },
                    {
                        value: 12,
                        text: "Total rating",
                        rating: 0,
                        comment: "",
                        comment_prop: "",
                        rating_prop: "",
                        type: 2,
                    },
                ],
            }
        },
        components: {
            StarRating,
        },
        computed: {
            total() {
                return this.rows.reduce((n, {
                    rating
                }) => n + rating, 0);
            },
            ratingStyle() {
                return this.mobile_break ? "" : " width: 50px; max-width: 50px";
            },
            mobile_break() {
                return this.$vuetify.breakpoint.mdAndUp;
            },
        },
        methods: {

            rowStyle(row) {
                switch (row.type) {
                    case 0:
                        return !this.mobile_break ? "font-size: 10px" : "";
                    case 1:
                        return !this.mobile_break ?
                            "font-weight: 600; font-size: 12px" :
                            "font-weight: 600; font-size: 16px";
                    case 2:
                        return !this.mobile_break ?
                            "font-weight: 600; font-size: 14px" :
                            "font-weight: 600; font-size: 18px";
                    default:
                        return "";
                }
            },
            show(item) {
                let self = this;
                this.dialog = true;
                this.item = item;
                var result = Object.keys(item).map((key) => [key, item[key]]);
                result.forEach(element => {
                    self.rows.forEach(el => {
                        if (element[0] == el.rating_prop) {
                            el.rating = element[1]
                        }
                        if (element[0] == el.comment_prop) {
                            el.comment = element[1]
                        }
                    });
                });
            },
            hide() {
                this.dialog = false;
                this.item = null;
            },
        }
    }
</script>

<style>
    .my-table {
        border-collapse: collapse;
        border: 1px solid black;
    }
</style>